export default __webpack_public_path__ + "static/media/628A5B86-FA19-4041-BCA0-3515B17784F5_1_105_c.9c1b1c48.jpeg";